import { useTheme } from '@emotion/react'
import BreadcrumbHeader from 'layout/BreadcrumbsHeader'
import React, { useCallback, useState } from 'react'
import NeedHelpButton from 'ui-components/NeedHelpButton'
import ThemeBGWrapper from 'ui-components/ThemeBGWrapper'
import CustomTabs from 'ui-components/CustomTabs'
import { TabContext } from '@mui/lab'
import AsyncTableListing from 'ui-components/AsyncTableListing'
import { Box, Grid, Button, MenuItem, Select, InputAdornment, IconButton, useMediaQuery, Autocomplete, Tooltip } from '@mui/material'
import CustomInputField from 'ui-components/CustomInputField'
import { Search as SearchIcon, Visibility as VisibilityIcon, Receipt as ReceiptIcon, Search, FilterAltRounded, FilterAltOutlined } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'
import { makeStyles } from '@mui/styles'
import { Primary, Secondary } from 'ui-components/Buttons';import ModalComponent from 'ui-components/ModalComponent'
import FilterPopup from './popups/FilterPopup'
import moment from 'moment'
import { capitalizedSentence } from 'utils/index'
import placeHolderImage from "assets/no_data_images/BackrrStartups/no_data_feedbacks_views.svg"
import OneTimePurchases from './OneTime'
import Subscriptions from './Subscriptions'

const useStyles = makeStyles((theme) => ({
    scrollTabs: {
        "&": {
            padding: "3rem"
        }
        // '& .MuiTabs-root > .MuiTabs-scroller > .MuiTabs-flexContainer' : {marginLeft: '2rem', gap: '5rem'}
    }
    //     '& .MuiTabs-root > .Mui-disabled.MuiTabs-scrollButtons': {
    //         display: 'none !important',
    //         transition: 'all 1s ease'
    //     },
    // }
}));

const tabs = [
    { label: 'Subscriptions', value: 'subscriptions' },
    { label: 'One-Time Purchases', value: 'one_time' }
]

const StartupPurchases = ({ value }) => {
    const theme = useTheme();
    const navigate = useNavigate();
    const classes = useStyles();
    const isSmall = useMediaQuery(theme.breakpoints.down('sm'));

    const [count, setCount] = useState(null);
    const [loading, setLoading] = useState(false);

    const [tabValue, setTabValue] = React.useState(value ?? 'subscriptions')

    const handleTabChange = (e, value) => {
        setLoading(true)
        setCount(null);
        setTabValue(value);
        navigate(`/startup_purchases/${value}`, { replace: true });
        setLoading(false)
    }

    return (
        <ThemeBGWrapper bgColor={theme.palette.customColors.yellow_bg}>
            <BreadcrumbHeader title={"Startup Purchases"} sx={{ paddingBottom: 0 }} Actions={() => <NeedHelpButton />} />

            <Box sx={{ padding: '1rem 2rem' }}>
                <TabContext value={tabValue}>
                    <CustomTabs data={[...tabs
                        ?.map(item => {
                            return ({ ...item, label: `${item?.label} ${tabValue === item?.value && tabValue && count && count != 0 && loading == false ? `(${count})` : ""}` })
                        })]}
                        value={tabValue} sx={{ border: '0px solid black !important' }}
                        bgColor={"transparent"}
                        allowScrollButtonsMobile={true} handleChange={handleTabChange} className={classes.scrollTabs} />
                </TabContext>
                {tabValue === "subscriptions" ? <Subscriptions setCount={setCount} setLoading={setLoading} /> : <OneTimePurchases setCount={setCount} setLoading={setLoading} />}
            </Box>
        </ThemeBGWrapper>
    )
}

export default StartupPurchases